// Support for Element.closest() (missing in IE)
// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
import 'element-closest';

// Support for URL and URLSearchParams classes (missing in IE)
// https://developer.mozilla.org/en-US/docs/Web/API/URL
import 'url-polyfill';

// Patch the Document.cookie property to ensure that all cookies are set
// SameSite=Lax if another SameSite value isn't already provided.
//
// TODO (nkohari): If/when we add this to the stripe-cookies library,
// we should remove this from here.
(function() {
  try {
    const property = Object.getOwnPropertyDescriptor(
      Document.prototype,
      'cookie',
    );
    if (property && property.get && property.set) {
      Object.defineProperty(document, 'cookie', {
        get(...args) {
          return property.get.apply(this, args);
        },
        set(val) {
          let newVal = val;
          if (!val.match(/samesite/i)) {
            newVal += '; SameSite=Lax';
          }
          return property.set.apply(this, [newVal]);
        },
      });
    }
  } catch (err) {}
})();
